<template>
  <div class="get-today-detail">
    <ModalAsideBody>
      <p class="get-today-detail__text">
        <span>
          {{ messages.reserveDetails }}
        </span>
      </p>
      <div v-if="reserveShop" class="get-today-shop">
        <h6 class="get-today-title">
          {{ messages.shop }}
        </h6>
        <p class="get-today-shop__address">
          {{ reserveShop.address }}
        </p>
        <p class="get-today-shop__phone">
          {{ reserveShop.phone }}
        </p>
        <p class="get-today-shop__time">
          {{ reserveShop.schedule }}
        </p>
      </div>
      <h6 class="get-today-title">
        <span>
          {{ messages.jewelry }}
        </span>
      </h6>

      <ProductModal :result="result" :messages="messages" />
      <h6 class="get-today-title">
        <span>
          {{ messages.fillOutForm }}
        </span>
      </h6>
      <form id="getTodayForm" class="get-today-form" @submit.prevent="handlerSubmit">
        <input type="hidden" name="deliveryId" value="2" />
        <input type="hidden" name="saveBasket" value="Y" />
        <input type="hidden" name="orderType" value="Резерв" />
        <input type="hidden" name="productId" :value="id" />
        <input type="hidden" name="article" :value="article" />
        <input
          v-if="getActiveSize"
          type="hidden"
          name="size"
          :value="getActiveSize?.displayValue"
        />
        <input type="hidden" name="storeId" :value="reserveShop.id" />
        <input type="hidden" name="storeXmlId" :value="reserveShop.xmlId" />
        <input type="hidden" name="quantity" :value="quantity || 1" />
        <DefInput
          name="surname"
          :placeholder="messages.surname"
          :value="authInfo.surname"
          :required="true"
        />
        <DefInput
          name="name"
          :placeholder="messages.name"
          :value="authInfo.user_name"
          :required="true"
        />
        <DefPhone
          name="phone"
          :placeholder="messages.phone"
          :value="authInfo.user_phone_number"
          :required="true"
          :only-countries="['UA']"
        />
      </form>
    </ModalAsideBody>
    <ModalAsideBottom>
      <DefButtonPrimary type="submit" form="getTodayForm">
        {{ messages.submitAnOrder }}
      </DefButtonPrimary>
    </ModalAsideBottom>
  </div>
</template>

<script setup>
import { defineProps, computed } from 'vue';
import ProductModal from '@components/Product/ProductModal.vue';
import DefInput from '@components/Def/DefInput/DefInput.vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import useModal from '@use/useModal/useModal';
import useModalAside from '@use/useModalAside/useModalAside';
import DefBuyOneClickThanks from '@components/Def/DefBuyOneClick/DefBuyOneClickThanks.vue';
import { useStore } from '@store';
import Analytics from '@/utils/Analytics';
import DefPhone from '@components/Def/DefPhone/DefPhone.vue';
import ModalAsideBody from '@use/useModalAside/ModalAsideBody.vue';
import ModalAsideBottom from '@use/useModalAside/ModalAsideBottom.vue';
import Recaptcha3 from '../../../utils/Recaptcha3';

const { result, messages, reserveShop } = defineProps(['result', 'messages', 'reserveShop']);
const modal = useModal();
const modalAside = useModalAside();

const {
  state: {
    personal: {
      data: { authInfo },
    },
    product: { data: productData },
  },
  dispatch,
  commit,
} = useStore();

const id = computed(() => result?.offer?.id ?? result?.id);
const quantity = computed(() => result?.price?.quantity);
const article = computed(() => result?.article);
const getActiveSize = computed(() => result?.skuMatrix?.SIZES?.items?.find((el) => el.active));

const handlerSubmit = async ({ target }) => {
  try {
    commit('global/loaderStart');
    const formData = new FormData(target);
    const token = await Recaptcha3.getSubmitToken();
    formData.append('g-recaptcha-response', token);

    const requestData = {};

    for (const pair of formData.entries()) {
      requestData[pair[0]] = pair[1];
    }

    const responseData = await dispatch('basket/createOrderByOneClick', requestData);

    const dataLayer = responseData?.dataLayer;
    const actionField = responseData?.dataLayer?.actionField;

    if (dataLayer) {
      Analytics.buyOneClick([...dataLayer.products], {
        transaction_id: actionField.id,
        affiliation: 'Online Store Sova',
        value: actionField.revenue,
        // tax: "4.90",
        shipping: actionField.shipping.price,
        currency: actionField.shipping.currency,
        coupon: actionField.coupon,
      });
    }

    modalAside.hide();
    modal.show(DefBuyOneClickThanks, { result: responseData }, { width: '500px' });
  } catch (err) {
    console.error(err);
  } finally {
    commit('global/loaderStop');
  }
};
</script>

<script>
export default {
  name: 'GetTodayDetail',
};
</script>

<style lang="scss" scoped>
.get-today-detail {
  height: 100%;
  &__text {
    font-weight: 500;
    font-size: rem(14);
    line-height: 125%;
    color: var(--color-dark-grey);
    margin-bottom: 32px;
  }
  :deep(.product-modal) {
    margin-bottom: 32px;
    @include point-md {
      margin-bottom: 40px;
    }
  }
}
.get-today-shop {
  margin-bottom: 32px;
  @include point-md {
    margin-bottom: 40px;
  }
  &__address {
    font-weight: 700;
    font-size: rem(14);
    line-height: 125%;
    margin-bottom: 8px;
  }
  &__phone,
  &__time {
    font-weight: 500;
    font-size: rem(14);
    line-height: 125%;
    color: var(--color-dark-grey);
  }
}
.get-today-title {
  font-weight: 600;
  font-size: rem(14);
  line-height: 130%;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-bottom: 16px;
  @include point-md {
    font-size: rem(16);
    margin-bottom: 24px;
  }
}
.get-today-form {
  display: grid;
  grid-gap: 16px;
  max-width: 480px;
  :deep(.def-button-primary) {
    margin-top: 8px;
    @include point-md {
      margin-top: 16px;
      max-width: 280px;
    }
  }
}
</style>
